export const SERVICES = [
  {
    id: "ponteggi",
    title: "Ponteggi & Messa in Sicurezza",
    tag: "SICUREZZA & QUOTA",
    desc: "Interventi tempestivi di messa in sicurezza, montaggio ponteggi e ripristino edili a qualsiasi altezza.",
    span: "md:col-span-2 md:row-span-2",
    image: "https://images.unsplash.com/photo-1649320316177-775fe2d67ca3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "facciate",
    title: "Pulizia Facciate & Marciapiedi",
    tag: "DECORO URBANO",
    desc: "Idrolavaggio ad alta pressione, rimozione graffiti e ripristino superfici esterne e pavimentazioni.",
    span: "",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "tetti",
    title: "Riparazione Tetti & Tegole",
    tag: "COPERTURE",
    desc: "Sostituzione tegole danneggiate, impermeabilizzazione falde e riparazione infiltrazioni d'acqua.",
    span: "",
    image: "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "balconi",
    title: "Impermeabilizzazione Balconi",
    tag: "ISOLAMENTO",
    desc: "Trattamenti impermeabilizzanti avanzati per terrazzi, balconi e cornicioni esposti ad agenti atmosferici.",
    span: "",
    image: "https://images.unsplash.com/photo-1513694203232-719a280e022f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "grondaie",
    title: "Grondaie & Discendenti",
    tag: "LATTONERIA",
    desc: "Sostituzione, pulizia e riparazione grondaie, pluviali e discendenti per corretto deflusso acque piovane.",
    span: "",
    image: "https://images.unsplash.com/photo-1634853982486-c06f0e17940f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "potatura",
    title: "Potatura Alberi Alto Fusto",
    tag: "VERDE & ARBORICOLTURA",
    desc: "Potatura professionale di alberi ad alto fusto, pini, piante secolari e sagomatura siepi con piattaforme aeree.",
    span: "md:col-span-2",
    image: "https://images.unsplash.com/photo-1754322449185-31f56117ed87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "interni",
    title: "Ripristino Interni",
    tag: "RISTRUTTURAZIONE",
    desc: "Pittura, cartongesso, riparazione danni da umidità e ripristino ambienti interni residenziali e commerciali.",
    span: "",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "dissuasori",
    title: "Dissuasori Volatili & Reti",
    tag: "DISINFESTAZIONE",
    desc: "Installazione dissuasori spillo, reti anti-intrusione piccioni e protezione monumenti e cornicioni.",
    span: "",
    image: "https://images.unsplash.com/photo-1582959998676-72d22466d6d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "fabbro",
    title: "Servizio Fabbro & Carpenteria",
    tag: "METALLO & SICUREZZA",
    desc: "Serrature di sicurezza, apertura porte, saldature, riparazione cancelli, inferriate e strutture metalliche.",
    span: "",
    image: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "traslochi",
    title: "Traslochi & Deposito Mobili",
    tag: "LOGISTICA",
    desc: "Traslochi completi per abitazioni e uffici, imballaggio professionale e custodia mobili in deposito.",
    span: "",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "pulizie",
    title: "Pulizie Aree & Smaltimento",
    tag: "ECOLOGIA",
    desc: "Pulizia profonda aree dismesse, cantine, solai e smaltimento autorizzato di rifiuti ingombranti.",
    span: "",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    id: "esterni",
    title: "Pavimentazioni & Asfalto",
    tag: "TERRAZZAMENTI",
    desc: "Pavimentazioni per esterni, asfalti, scavi e movimentazione terra con macchinari propri.",
    span: "",
    image: "https://images.unsplash.com/photo-1584467735871-8e85353a8413?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const CONTACTS = {
  sede: { label: "Sede Centrale", number: "+39 06 83932445", href: "tel:+390683932445" },
  diretto: { label: "Diretto / Emergenze H24 — Daniele Peluso", number: "+39 338 1072423", href: "tel:+393381072423" },
  email: "info@pelusoservice.it",
  addresses: [
    { city: "Roma", address: "Via Salaria Km 20.200 — 00138 Roma (RM)" },
    { city: "Monterotondo", address: "Via Leonardo da Vinci 95 — Z.I. Monterotondo (RM)" },
  ],
};
